import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

import styles from './clearIndicator.module.scss'

const ClearIndicator = () => {
    return <FontAwesomeIcon className={styles.icon} icon={faTimes} />
}

export default ClearIndicator
